import { TENANT_AT, TENANT_COM, TENANT_IT } from 'shared/consts'

export const EXPA_TOP_SLIDER = ['gglp']
export const TENANT_TOP_SLIDER = [TENANT_COM, TENANT_AT, TENANT_IT]
